import { render, staticRenderFns } from "./materialRequisitionForm.vue?vue&type=template&id=a316d9aa&scoped=true&"
import script from "./materialRequisitionForm.vue?vue&type=script&lang=js&"
export * from "./materialRequisitionForm.vue?vue&type=script&lang=js&"
import style0 from "./materialRequisitionForm.vue?vue&type=style&index=0&id=a316d9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a316d9aa",
  null
  
)

export default component.exports